
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitopuneonewaycab() {



    const cardData =
    {
        keyword: 'Mumbai to Pune One Way Cab',
        heading: 'Vedant Travels: Mumbai to Pune One Way Cab',
        headingDescription: 'Vedant Travels offers reliable, affordable, and transparent taxi services for a one-way trip from Mumbai to Pune. Our service ensures a comfortable and seamless journey with no hidden charges. We provide various cab options to suit your travel preferences and budget, whether you are looking for a sedan, SUV, or premium vehicle. Enjoy a hassle-free ride with our competitive pricing and professional drivers.',

        top: 'Top Places to Visit in Pune with Vedant Travels',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "A historical fortification in the heart of Pune, Shaniwar Wada is a significant landmark showcasing Maratha architecture and history. The fort offers insight into the grandeur of the Peshwa Empire, and its light-and-sound show is a must-see in the evenings."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Built in 1892, the Aga Khan Palace is a magnificent piece of architecture with historical significance. It is famous for its role in the Indian freedom struggle and for housing Mahatma Gandhi and his associates during their imprisonment. The palace is a serene spot to learn about India’s freedom movement."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Located about 35 km from Pune, Sinhagad Fort is a popular trekking destination offering panoramic views of the surrounding region. Rich in history, the fort played a crucial role in the Maratha Empire and is now a popular site for picnics and adventure lovers."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho Ashram is an internationally renowned meditation center that offers a peaceful and rejuvenating environment. Visitors can indulge in meditation, yoga, and spiritual practices under the guidance of experienced masters."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "The Raja Dinkar Kelkar Museum houses a vast collection of artifacts from India’s rich cultural history. The museum includes sculptures, paintings, musical instruments, and everyday items that provide insight into traditional Indian art and culture."
            },
            {
                "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
                "description": "A beautiful Japanese-style garden located on the banks of the Mula-Mutha River, this garden is perfect for a peaceful stroll. With beautiful landscapes, flower beds, and ponds, it provides a serene environment away from the hustle and bustle of the city."
            },
            {
                "title": "Pashan Lake",
                "description": "Pashan Lake is a popular spot for nature lovers and birdwatchers. The lake is surrounded by lush greenery, making it an ideal place for picnics, leisurely walks, and photography. It is especially beautiful during the monsoon season."
            },
            {
                "title": "Bund Garden",
                "description": "Bund Garden is a beautiful riverside park in Pune, offering peaceful surroundings for a walk or picnic. The garden has boating facilities and is perfect for a relaxing afternoon with family and friends."
            },
            {
                "title": "Saras Baug",
                "description": "Saras Baug is a popular garden in Pune that offers a relaxing escape with scenic views. The garden has a temple dedicated to Lord Ganesha, making it an important religious and cultural landmark in the city."
            },
            {
                "title": "Fergusson College",
                "description": "One of the oldest and most prestigious colleges in Pune, Fergusson College is also a historic building with beautiful architecture. It’s a great spot to visit for those interested in history, architecture, and the educational landscape of Pune."
            }
        ],

"services": [
    {
        "name": "Mumbai Pune Cab One Way",
        "description": "Looking for a Mumbai Pune Cab One Way? At Vedant Travels, we offer affordable and reliable one-way cab services between Mumbai and Pune. Whether you're traveling for business or leisure, our service ensures a comfortable and stress-free journey."
    },
    {
        "name": "One Way Taxi Mumbai to Pune",
        "description": "Book a One Way Taxi Mumbai to Pune with Vedant Travels and enjoy a smooth ride with professional drivers. Our fleet includes a variety of vehicles, from sedans to SUVs, ensuring you get the perfect option for your travel needs."
    },
    {
        "name": "Mumbai Pune One Way Drop",
        "description": "If you're looking for a Mumbai Pune One Way Drop, Vedant Travels provides flexible and affordable taxi options. We offer convenient drop-off services, ensuring a seamless travel experience from Mumbai to Pune, whether it's for a one-way trip or just a short ride."
    },
    {
        "name": "One Way Cab Pune to Mumbai Airport",
        "description": "Need a One Way Cab Pune to Mumbai Airport? Vedant Travels offers reliable one-way taxi services that ensure you reach the airport on time. Whether it's for an early morning flight or a late-night departure, we guarantee punctuality and comfort for your journey."
    },
    {
        "name": "One Way Mumbai to Pune",
        "description": "For those traveling One Way Mumbai to Pune, Vedant Travels provides efficient, reliable, and comfortable taxi services. Our experienced drivers know the best routes, ensuring a hassle-free and timely arrival at your destination."
    },
    {
        "name": "Pune to Mumbai Airport One Way Cab",
        "description": "For a smooth ride, opt for our Pune to Mumbai Airport One Way Cab service. We offer a variety of vehicles that ensure comfort and convenience, so you can travel without worry, arriving at the airport on time."
    },
    {
        "name": "Mumbai Pune One Way Innova Taxi",
        "description": "Travel in comfort with our Mumbai Pune One Way Innova Taxi service. The Innova is a spacious and comfortable option for those who want extra room during their journey. Book an Innova for a premium, smooth ride from Mumbai to Pune."
    },
    {
        "name": "Mumbai Pune One Way Sedan Taxi",
        "description": "Our Mumbai Pune One Way Sedan Taxi service offers the perfect combination of comfort and affordability. Ideal for solo travelers or small groups, our sedan taxis ensure a smooth and comfortable journey from Mumbai to Pune."
    },
    {
        "name": "Mumbai Pune One Way Drop",
        "description": "Whether you’re heading for business or leisure, our Mumbai Pune One Way Drop service offers flexibility and convenience. Enjoy a safe, efficient, and comfortable ride at competitive prices with Vedant Travels."
    },
    {
        "name": "Mumbai to Pune One Way Ertiga Drop",
        "description": "Looking for a Mumbai to Pune One Way Ertiga Drop? The Ertiga offers plenty of space and comfort for group travelers or families. Book this option for a smooth and affordable journey from Mumbai to Pune."
    },
    {
        "name": "Mumbai to Pune One Way Cab",
        "description": "For a Mumbai to Pune One Way Cab, Vedant Travels is your go-to service provider. We offer a wide range of vehicles, from economy options to premium rides, to cater to your specific needs and preferences."
    },
    {
        "name": "Mumbai Pune Cab One Way",
        "description": "At Vedant Travels, we provide the best Mumbai Pune Cab One Way services. With a fleet of modern and well-maintained vehicles, we ensure that your one-way trip is comfortable, affordable, and safe."
    },
    {
        "name": "One Way Cab Pune to Mumbai",
        "description": "For a One Way Cab Pune to Mumbai, our service is the most convenient choice. Whether you're coming from Pune to Mumbai for business or leisure, we provide reliable, punctual, and affordable one-way cab services."
    },
    {
        "name": "Pune to Mumbai Taxi One Way",
        "description": "Looking for a Pune to Mumbai Taxi One Way? Vedant Travels offers flexible and affordable taxi services for one-way trips. Our experienced drivers ensure a comfortable and timely journey between Pune and Mumbai."
    },
    {
        "name": "Pune Mumbai Cab One Way",
        "description": "Book a Pune Mumbai Cab One Way with Vedant Travels for a comfortable and hassle-free journey. Our cabs are available for one-way trips at competitive rates, ensuring that your travel experience is smooth and pleasant."
    },
    {
        "name": "One Way Taxi Mumbai to Pune",
        "description": "Opt for a One Way Taxi Mumbai to Pune with Vedant Travels, and enjoy a seamless and comfortable journey. With our reliable fleet and professional drivers, you can trust us to get you from Mumbai to Pune safely and on time."
    },
    {
        "name": "One Way Cab Pune to Mumbai Airport",
        "description": "If you need a One Way Cab Pune to Mumbai Airport, our service ensures timely and comfortable travel. Whether it’s a morning or night flight, our one-way cab service guarantees punctuality and convenience."
    },
    {
        "name": "One Way Mumbai to Pune",
        "description": "For a One Way Mumbai to Pune journey, book with Vedant Travels for the best taxi service. We provide competitive rates and a variety of vehicles, ensuring a smooth and comfortable trip between the two cities."
    },
    {
        "name": "One Way Pune to Mumbai",
        "description": "Choose our One Way Pune to Mumbai cab service for a reliable, affordable, and comfortable ride. Our drivers ensure you arrive at your destination on time and in style."
    }
],


"tableData": [
    ["Mumbai Pune Cab One Way", "One Way Taxi Mumbai to Pune"],
    ["Mumbai Pune One Way Drop", "One Way Cab Pune to Mumbai Airport"],
    ["One Way Mumbai to Pune", "Pune to Mumbai Airport One Way Cab"],
    ["Mumbai Pune One Way Innova Taxi", "Mumbai Pune One Way Sedan Taxi"],
    ["Mumbai Pune One Way Drop", "Mumbai to Pune One Way Ertiga Drop"],
    ["Mumbai to Pune One Way Cab", "Mumbai Pune Cab One Way"],
    ["One Way Cab Pune to Mumbai", "Pune to Mumbai Taxi One Way"],
    ["Pune Mumbai Cab One Way", "One Way Taxi Mumbai to Pune"],
    ["One Way Cab Pune to Mumbai Airport", "One Way Mumbai to Pune"],
    ["One Way Pune to Mumbai", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we know how important it is to travel without delays, especially for one-way trips. Whether you're heading from Mumbai to Pune for business or leisure, our drivers ensure timely pickups and drop-offs, so you can enjoy a smooth and punctual journey."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "We offer a wide range of comfortable and spacious vehicles for your Mumbai to Pune One Way Cab ride. Choose from our sedans, SUVs, and premium cars, all designed with ample legroom, air conditioning, and comfortable seating to ensure a pleasant travel experience."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes from Mumbai to Pune. They are committed to providing a safe, smooth, and efficient journey, making sure you reach your destination without any hassle."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers affordable and competitive pricing for your Mumbai to Pune One Way Cab. Our pricing model is transparent, with no hidden charges, so you get excellent value for your money without any surprises."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. All of our vehicles are equipped with modern safety features like seat belts, airbags, and GPS tracking. Our drivers follow strict safety protocols to ensure that your journey from Mumbai to Pune is secure and worry-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you need to travel early in the morning or late at night, Vedant Travels is available round the clock. You can book your Mumbai to Pune One Way Cab at any time, and our customer service team will be happy to assist you."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking a Mumbai to Pune One Way Cab is quick and easy. You can book online via our website or mobile app, or simply contact our customer service team for assistance. We aim to make the booking process as smooth and simple as possible for you."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We understand that every traveler has different needs. We offer customized travel packages for your Mumbai to Pune One Way trip, whether you’re traveling for business, leisure, or any other purpose. Let us know your preferences, and we’ll tailor the journey to suit your needs."
    }
  ]







    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Pune One Way cab with Vedant Travels?',
            answer: 'You can easily book your Mumbai to Pune One Way Cab through our website or mobile app. Alternatively, our customer service team is available to assist you with the booking process.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes for long-distance travel such as Mumbai to Pune. They ensure a smooth, safe, and efficient journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Pune One Way travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, all of which are spacious, comfortable, and well-maintained to ensure a pleasant journey.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Pune One Way cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, so you can choose the method that’s most convenient for you.',
        },
        {
            id: 5,
            question: 'Can I book a return trip along with my Mumbai to Pune One Way cab?',
            answer: 'Yes, you can book a round-trip cab. Just provide your return details during the booking process, and we’ll arrange the entire journey for you.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront during the booking process. We value transparency and ensure no hidden fees.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Pune after my drop-off?',
            answer: 'Yes, we offer customized sightseeing tours in Pune after your Mumbai to Pune One Way trip. Explore famous attractions like Shaniwar Wada, Aga Khan Palace, and more with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Pune One Way cab?',
            answer: 'Our vehicles can accommodate standard luggage. If you have more luggage or specific requirements, please inform us at the time of booking, and we’ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Mumbai and Pune?',
            answer: 'Yes, we offer corporate travel services between Mumbai and Pune. Whether it’s for meetings, conferences, or team outings, we can provide customized travel packages tailored to your company’s needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my Mumbai to Pune One Way journey?',
            answer: 'Vedant Travels offers reliable, safe, and comfortable travel services with experienced drivers, well-maintained vehicles, competitive pricing, and 24/7 availability. We ensure that your Mumbai to Pune One Way journey is smooth, hassle-free, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sanjay Mehta",
            title: "Customer",
            quote: "I booked a Mumbai to Pune One Way cab with Vedant Travels for a business trip. The driver was on time, professional, and the vehicle was very comfortable. The entire journey was smooth, and I’ll definitely use their service again.",
            rating: 5,
        },
        {
            name: "Mrs. Radhika Sharma",
            title: "Customer",
            quote: "Our experience with Vedant Travels for our one-way trip from Mumbai to Pune was excellent. The cab was clean, spacious, and comfortable, and the driver was friendly and knowledgeable about the routes. We arrived in Pune on time and had a great experience overall.",
            rating: 5,
        },
    ];
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune One Way Cab",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-pune-one-way-cab.jpg",
  "description": "Book Mumbai to Pune one way cab with Vedant Travels for a hassle-free, safe, and affordable journey. Choose from AC sedans and SUVs for quick and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-pune-one-way-cab"
  }
};



      
   
      


    return (
        <div>
           
           <Helmet>
  <title>Mumbai to Pune One Way Cab | Safe & Quick | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune one way cab with Vedant Travels for a hassle-free, safe, and affordable journey. Choose from AC sedans and SUVs for quick and comfortable travel." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune One Way Cab, One Way Taxi Mumbai to Pune, Mumbai to Pune Cab Booking, AC Taxi Mumbai to Pune, SUV Cab Mumbai Pune, Vedant Travels Mumbai to Pune, Affordable Mumbai to Pune Cab, Quick Cab Mumbai to Pune, Online Cab Booking Mumbai to Pune, Reliable Taxi Mumbai to Pune, Comfortable Ride Mumbai to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopuneonewaycab;